import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import TabLayout from '../components/layouts/TabLayout';
import SplashScreen from '../screens/Splash';
import HomeScreen from '../screens/Home';
import LoginScreen from '../screens/Login';
import SignupScreen from '../screens/Signup';
import ForgotPasswordScreen from '../screens/ForgotPassword';
import BookScreen from '../screens/Book';
import LibraryScreen from '../screens/Library';
import SearchScreen from '../screens/Search';
import BrowseAllScreen from '../screens/BrowseAll';
import PopularAllScreen from '../screens/PopularAll';
import ProfileHubScreen from '../screens/ProfileHub';
import EditProfileScreen from '../screens/Profile';
import PdfViewerScreen from '../screens/PdfViewer';
import ChangePasswordScreen from '../screens/ChangePassword';
import HelpScreen from '../screens/Help';

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      {/* Splash */}
      <Route path="/" element={<SplashScreen />} />

      {/* Auth (no tab bar) */}
      <Route path="/login" element={<LoginScreen />} />
      <Route path="/signup" element={<SignupScreen />} />
      <Route path="/forgot-password" element={<ForgotPasswordScreen />} />

      {/* Tab layout routes */}
      <Route path="/app" element={<TabLayout />}>
        <Route path="home" element={<HomeScreen />} />
        <Route path="library" element={<LibraryScreen />} />
        <Route path="search" element={<SearchScreen />} />
        <Route path="profile" element={<ProfileHubScreen />} />
        <Route path="profile/edit" element={<EditProfileScreen />} />
        <Route path="profile/password" element={<ChangePasswordScreen />} />
        <Route path="profile/help" element={<HelpScreen />} />
        <Route index element={<Navigate to="home" replace />} />
      </Route>

      {/* Standalone screens (no tab bar) */}
      <Route path="/book" element={<BookScreen />} />
      <Route path="/pdf-viewer" element={<PdfViewerScreen />} />
      <Route path="/app/browse" element={<BrowseAllScreen />} />
      <Route path="/app/popular" element={<PopularAllScreen />} />

      {/* Legacy redirects */}
      <Route path="/home" element={<Navigate to="/app/home" replace />} />
      <Route path="/downloads" element={<Navigate to="/app/library" replace />} />
      <Route path="/settings" element={<Navigate to="/app/profile" replace />} />
      <Route path="/profile" element={<Navigate to="/app/profile/edit" replace />} />
      <Route path="/change-password" element={<Navigate to="/app/profile/password" replace />} />
      <Route path="/help" element={<Navigate to="/app/profile/help" replace />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

export default AppRoutes;
